import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, combineLatest, switchMap, distinctUntilChanged } from 'rxjs';

import { CurrencyService } from '@fcom/core';

/**
 * Asynchronous offers price pipe that supports localizations.
 * Uses currencyService to get price in localized format.
 */
@Injectable()
@Pipe({
  name: 'finOffersPrice',
  pure: true,
  standalone: false,
})
export class OffersPricePipe implements PipeTransform {
  private currencyService = inject(CurrencyService);

  transform(
    offerPrice$: Observable<string>,
    offerCurrencyCode$: Observable<string>,
    doPriceRounding = false
  ): Observable<string> {
    return combineLatest([
      offerPrice$.pipe(distinctUntilChanged()),
      offerCurrencyCode$.pipe(distinctUntilChanged()),
    ]).pipe(
      switchMap(([amount, currencyCode]) =>
        this.currencyService.formatPrice({ amount, currencyCode }, { roundPrice: doPriceRounding })
      )
    );
  }
}
